import { render, staticRenderFns } from "./edit-incomeRecord.vue?vue&type=template&id=e424ffa0"
import script from "./edit-incomeRecord.vue?vue&type=script&lang=ts"
export * from "./edit-incomeRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports